"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUBSCRIPTION_REQUIRED_ERROR_MESSAGE = exports.FREE_SCAN_LIMIT = exports.PermissionSchema = exports.PERMISSIONS = void 0;
exports.permissionsForEntitlements = permissionsForEntitlements;
const zod_1 = require("zod");
const billing_1 = require("./billing");
/**
 * Canonical Stella permission strings. Format `feature:<slug>`; the namespace
 * leaves room for non-feature scopes later (`admin:*`). Adding a gated feature:
 * append here, then map it in `permissionsForEntitlements`.
 */
exports.PERMISSIONS = ['feature:scan', 'feature:weekly_report'];
exports.PermissionSchema = zod_1.z.enum(exports.PERMISSIONS);
/**
 * Pure entitlement→permission resolver. Shared by the backend gate and the
 * frontend `usePermissions` hook so the two views can never disagree. One tier
 * today: `stella_premium` grants every gated feature.
 */
function permissionsForEntitlements(entitlementIds) {
    const granted = new Set();
    for (const id of entitlementIds) {
        if (id === billing_1.STELLA_PREMIUM_ENTITLEMENT) {
            granted.add('feature:scan');
            granted.add('feature:weekly_report');
        }
    }
    return granted;
}
/**
 * Lifetime number of free (non-failed) scans before `feature:scan` is required.
 */
exports.FREE_SCAN_LIMIT = 1;
/**
 * Stable message thrown by the backend gate when a user lacks a permission.
 * The frontend matches this literal to route into the paywall.
 */
exports.SUBSCRIPTION_REQUIRED_ERROR_MESSAGE = 'SUBSCRIPTION_REQUIRED';
//# sourceMappingURL=permissions.js.map